<template>
  <div class="icu-date-wrapper">
    <input-label v-if="label">
      {{ fieldLabel }}
    </input-label>
    <div class="icu-date">
      <v-date-picker
        ref="datepicker"
        v-bind="{
          'is-required': true,
          popover: {
            visibility: 'focus'
          },
          masks: {
            input: 'DD.MM.YYYY',
          },
          ...vCalendarOptions
        }"
        :locale="$i18n.locale"
        :value="value"
        @input="emitInput"
      >
        <template #default="{inputValue, inputEvents}">
          <text-input
            ref="input"
            class="icu-date__input"
            :value="value? inputValue: ''"
            :placeholder="placeholder"
            :mask-options="maskOptions"
            :emit-input-as-event="true"
            @focusin="isFieldInFocus = true"
            @focusout="isFieldInFocus = false"
            @input="inputHandler"
            v-on="inputEvents"
          />
        </template>
      </v-date-picker>
      <icu-icon icon-name="calendar" class="icu-date__calendar-icon" />
    </div>
    <input-error v-if="errorMessage">
      {{ $t(errorMessage) }}
    </input-error>
    <template v-else-if="isFieldInFocus">
      <slot name="hint">
        <input-hint v-if="hint" class="icu-date__hint">
          {{ hint }}
        </input-hint>
      </slot>
    </template>
  </div>
</template>

<script>
import InputError from '@/components/inputs/InputError.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputHint from '@/components/inputs/InputHint.vue'
import IcuIcon from '@/components/common/IcuIcon.vue'
import { format } from 'date-fns'
import TextInput from '@/components/inputs/TextInput'
export default {
  name: 'DateInput',
  components: {TextInput, IcuIcon, InputHint, InputLabel, InputError },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: null
    },
    vCalendarOptions: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      isFieldInFocus: false,
      maskOptions: {
        mask: Date,
        lazy: true
      },
    }
  },
  computed: {
    fieldLabel() {
      if (this.required) {
        return `${this.label} *`
      }

      return this.label
    },
    errorMessage() {
      return this.errors?.[0] || ''
    }
  },
  methods: {
    inputHandler(event){
      if(!event.target.value) {
        this.$emit('input', null)
      }
    },
    emitInput(value) {
      const newDate = value ? format(value, 'yyyy-MM-dd') : null
      this.$emit('input', newDate)
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/inputs/DateInput.scss";
</style>
